module.exports = __webpack_public_path__ + "static/media/5H.3a5059d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/5H.svg
// module id = 67
// module chunks = 0